// React Imports
import React, {Component} from "react";

export default class Footer extends Component {
    render() {
        return <div className="row mingles-footer">
            <div className="mingles-footer-social">
                <a href="https://www.facebook.com/portraitswithpastels" target="_blank"><i className="fa fa-facebook-f" /></a>
                <a href="https://www.instagram.com/portraitswithpastels/" target="_blank"><i className="fa fa-instagram"/></a>
            </div>
            <div className="mingles-footer-mingles">
                <a href="http://www.portraitswithpastels.com">portraits with pastels</a>
            </div>
        </div>;
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/